import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getDateData, getDateString } from "../common/HelperFunctions";
import flatpickr from "flatpickr";
import Select from "../common/Select";
import API from "../common/Api";

function numberWithCommas(x, zeros = 2) {
  x = Number(x);
  if (isNaN(zeros) || zeros < 0) {
    zeros = 2;
  }
  let parts = x.toFixed(zeros).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

export default class IndividualBookingDetails extends Component {
  flatpickr_date_picker = React.createRef();
  state = {
    reschedule: false,
    opening_hours: [],
    errors: { 'appointment_date': null },
    loading: false,
    selectedTime: null,
    selectedDate: null,
  };

  componentDidMount() {
    this.initFlatpickr();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.business !== prevProps.business ||
      this.state.reschedule !== prevState.reschedule
    ) {
      this.initFlatpickr();
    }
  }

  initFlatpickr = () => {
    const { business } = this.props;
    if (!business || !this.flatpickr_date_picker.current) return;
    const { opening_week_days } = business;

    try {
      if (this.flatpickr_date_picker.current && opening_week_days) {
        flatpickr(this.flatpickr_date_picker?.current, {
          enable: [
            function (date) {
              return opening_week_days.includes(
                getDateString(date, false, true).day
              );
            }
          ],
          minDate: (() => {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            return new Date(tomorrow);
          })(),
          onChange: (dates, selectedDate) => {
            this.getOpeningHours(selectedDate);
            this.setState({ selectedDate });
          },
          defaultDate: localStorage.getItem("booking date")
        });
      }
    } catch (err) {
      if (err.name === "SecurityError") {
        console.warn("Flatpickr initialization skipped unsafe stylesheet access:", err.message);
      } else {
        throw err;
      }
    }
  };

  getOpeningHours = date => {
    const { booking, headers, business } = this.props;
    this.setState({ errors: [], opening_hours: [], loading: true });
    const data = {
      appointment_date: date,
      team_member_id: `${booking.transaction.team_member_id}`
    };
    API.post(
      `personal/business/${business.identifier}/opening-hours`,
      data,
      headers
    )
      .then(
        ({
          data: {
            data: { opening_hours, teamMember }
          }
        }) => {
          const opening_hours_array = opening_hours.map(hour => hour.time);
          this.setState({ opening_hours: opening_hours_array });
          if (teamMember) {
            this.setState({ team: teamMember });
          }
        },
        ({
          response: {
            data: { errors }
          }
        }) => {
          if (errors)
            errors.forEach(err => {
              this.setState({
                errors: {
                  ...this.state.errors,
                  [err.field]: err.message
                }
              });
            });
        }
      )
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  submitDate = event => {
    event.preventDefault();
    const { booking, headers, onRefresh } = this.props;

    const form = event.currentTarget;
    const {
      date: { value: appointment_date },
      time: { value: appointment_start_time },
      reason: { value: reason }
    } = form;

    let data = {
      appointment_date,
      appointment_start_time,
      reason
    };

    if (data.appointment_date && data.appointment_start_time) {
      this.setState({ loading: true, errors: {} });
      API.post(
        `/business/reschedule-appointments/${booking.identifier}`, data,
        headers
      )
        .then(
          ({ data }) => {
            window.$.notify(data.message, "success-alert");
            if (onRefresh) onRefresh();
          },
          ({
            response: {
              data: { errors }
            }
          }) => {
            if (errors)
              errors.forEach(err => {
                this.setState({
                  errors: { ...this.state.errors, [err.field]: err.message }
                });
              });
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  sumServicesPrice = (services) => {
    if (!services || !Array.isArray(services)) return 0;
    return services.reduce((total, service) => total + (Number(service.price) || 0), 0);
  };

  render() {
    const { booking, showClientContact } = this.props;
    const handlesProcessingFee = booking?.transaction?.meta?.booking_settings?.handles_processing_fee || booking?.handles_processing_fee;

    return (
      <>
        <div className="card-section">
          <div className="info flex space-btw" style={{ justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <p className="date thick">
                {getDateData(booking.date, true, true)}
              </p>
              <p className="time">
                ({booking.start_time} - {booking.end_time})
              </p>
              <div className="co-pink" onClick={() => { this.setState({ reschedule: !this.state.reschedule }) }} style={{ cursor: "pointer" }}>
                Reschedule
              </div>
            </div>
            <p
              className="appointment-state"
              data-state={booking.status === 'reserved' ? 'booked' : booking.status}
            ></p>
          </div>
        </div>

        {this.state.reschedule && (
          <div className="card-section">
            <form onSubmit={this.submitDate}>
              <div className="info dp-container">
                <div style={{ marginBottom: "10px" }} className="input-rapper date">
                  <label htmlFor="">
                    <p className="label">New Date</p>
                    <input
                      required={true}
                      type="text"
                      name="date"
                      placeholder="Select date here"
                      ref={this.flatpickr_date_picker}
                    />
                  </label>
                  {this.state.errors.appointment_date && (
                    <p className="err">{this.state.errors.appointment_date}</p>
                  )}
                </div>
                <Select
                  style={{ height: "47px" }}
                  label="Time"
                  name="time"
                  required={true}
                  placeholder="Select time"
                  onChange={({ currentTarget: { value: selectedTime } }) => {
                    this.setState({ selectedTime });
                    localStorage.setItem("booking time", selectedTime);
                  }}
                  disabled={!this.state.opening_hours.length}
                  error={this.state.errors.appointment_start_time}
                >
                  {this.state.opening_hours?.map(value => (
                    <option
                      key={value}
                      value={value}
                      selected={value === localStorage.getItem("booking time")}
                    >
                      {value}
                    </option>
                  ))}
                </Select>
                <div className="input-rapper date">
                  <label htmlFor="">
                    <p className="label">Message (Optional)</p>
                    <textarea name="reason" placeholder="" />
                  </label>
                </div>
              </div>
              <button
                style={{ padding: "10px 20px" }}
                className={this.state.loading ? "default loading" : "default"}
              >
                Reschedule Now
              </button>
            </form>
          </div>
        )}

        <div className="card-section">
          <div className="info flex space-btw dp-container">
            <div>
              <p className="appointment-state" data-state="CUSTOMER INFO"></p>
              <p className="date thick">
                {booking.customer.first_name} {booking.customer.last_name}
              </p>
              {showClientContact && (
                <>
                  <p className="detail">
                    Phone:
                    <a href={`tel:${booking.customer.phone_number}`} target="blank" className="co-pink">
                      {" "}{booking.customer.phone_number}
                    </a>
                  </p>
                  <p className="detail">
                    Email:
                    <a href={`mailto:${booking.customer.email}`} target="blank" className="co-pink">
                      {" "}{booking.customer.email}
                    </a>
                  </p>
                  {booking &&
                    <p className="detail">
                      Customer Notes: <span className="notes-detail">{booking.booking_notes}</span>
                    </p>
                  }
                  {booking.transaction.address && (
                    <p className="detail">
                      Address:
                      <span className="address-detail"> {booking.transaction.address ?? 'N/A'}</span>
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="card-section" style={{ borderBottom: "0", paddingBottom: "0px" }}>
          <div className="info flex space-btw dp-container">
            <div>
              <p className="date thick-1">
                {booking.team_member.first_name} {booking.team_member.last_name}
              </p>
            </div>
          </div>

          {booking.services.map((service, index) => (
            <p key={index} className="flex space-btw">
              <span className="detail" style={{ fontWeight: '400' }}>
                <svg style={{ marginRight: '10px' }} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5294 9.99997C5.47864 9.99997 7.0588 8.4198 7.0588 6.47056C7.0588 4.52133 5.47864 2.94116 3.5294 2.94116C1.58017 2.94116 0 4.52133 0 6.47056C0 8.4198 1.58017 9.99997 3.5294 9.99997Z" fill="#2CB5E9" />
                  <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M3.41211 1.76612C4.02216 0.710399 5.1632 0 6.47016 0C8.4194 0 9.99956 1.58017 9.99956 3.5294C9.99956 4.83637 9.28916 5.97741 8.23344 6.58746C8.23439 6.54861 8.23486 6.50965 8.23486 6.47057C8.23486 3.87159 6.12797 1.7647 3.52899 1.7647C3.48992 1.7647 3.45096 1.76518 3.41211 1.76612Z" fill="#2CB5E9" />
                </svg>
                {service.name}
              </span>
              <span className="cash" style={{ color: '#171F46', fontWeight: '500' }}>
                ₦{numberWithCommas(service.price, 0)}
              </span>
            </p>
          ))}
        </div>

        <div className="card-section">
          <div className="details">
            <p className="flex space-btw" style={{ marginBottom: "10px" }}>
              <span className="detail cash" style={{ fontWeight: '800' }}>Service total</span>
              <span className="cash" style={{ fontWeight: '700' }}>
                ₦{numberWithCommas(this.sumServicesPrice(booking.services), 0)}
              </span>
            </p>

            <hr style={{ borderBottom: "1px solid #eaedf3" }} />
            <br />

            <p className="flex space-btw">
              <span className="detail cash" style={{ fontWeight: '800' }}>Amount paid</span>
              <span className="cash" style={{ fontWeight: '700' }}>₦{numberWithCommas(booking.amount_paid, 0)}</span>
            </p>
            <hr />

            <p className="flex space-btw">
              <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>
                - Upfront Payment ({booking.transaction.meta.booking_settings?.upfront_percentage_payment}%)
              </span>
              <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                ₦{(() => {
                  let amountPaid = booking.amount_paid;
                  let discountAmount = booking.transaction.discount_amount;
                  let priorityBooking = booking.priority_booking;
                  let rizevoCommission = booking.rizevo_commission;
                  let services_amount = this.sumServicesPrice(booking.services);

                  let upfrontPayment = amountPaid;

                  if (handlesProcessingFee !== 'business') {
                    upfrontPayment -= (priorityBooking + rizevoCommission);
                  } else {
                    upfrontPayment -= priorityBooking;
                  }
                  upfrontPayment += Math.min(discountAmount, services_amount);

                  return numberWithCommas(Math.max(upfrontPayment, 0), 0);
                })()}
              </span>
            </p>

            {booking.transaction.discount_code && (
              <p className="flex space-btw">
                <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>
                  - Discount ({booking?.discount?.code})
                </span>
                <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                  -₦{booking.transaction.discount_amount}
                </span>
              </p>
            )}

            {handlesProcessingFee !== 'business' && (
              <p className="flex space-btw">
                <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>- Processing Fee</span>
                <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                  ₦{booking.rizevo_commission}
                </span>
              </p>
            )}

            {booking.priority_booking ? (
              <p className="flex space-btw">
                <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>- Priority Booking</span>
                <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                  ₦{booking.priority_booking}
                </span>
              </p>
            ) : null}

            <p className="flex space-btw">
              <span className="detail cash" style={{ fontWeight: '800' }}>Balance</span>
              <span className="cash" style={{ fontWeight: '800' }}>₦{booking.transaction?.balance_amount ?? 0}</span>
            </p>
          </div>
        </div>
      </>
    );
  }
}
